import { getFullUrl } from '@lt/components/utils/userflow';
import type { ImageProps } from '@lt/components/components/Image/types';
import type { HotelImage } from '../../types';

// TODO: выпилить после унификации урлов на беке
const DOMAIN = 'img.cdn.level.travel/';

export const getPictureProps = (image: HotelImage): ImageProps => {
  const webpImageUrl = getFullUrl(image.webp, DOMAIN);
  const jpgImageUrl = getFullUrl(image.jpg, DOMAIN);
  const imageUrl = webpImageUrl || jpgImageUrl || '';
  const imageType = image.webp ? 'image/webp' : 'image/jpeg';

  return {
    src: imageUrl,
    fetchpriority: 'auto',
    loading: 'lazy',
    fallback: jpgImageUrl || '',
    type: imageType,
    alt: '',
  };
};
